const en_whs_itemin = {
    "": "item in",
    detail: "item in detail",
}

export default en_whs_itemin;